export default "__VITE_ASSET__BzXRaIP4__"